import { Button, Col, Form, List, Row, Select, Tooltip, Typography } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import swapElements from "../../../utilities/swapElements";
import { SORT_DIRECTION_LIST } from "./constants";
import sortFields from "./sortFields";
import { isArray } from "lodash-es";

const SortingField = ({ handleSetConfiguration, configuration, fieldName, title, titleTooltip }) => {
  const { formatMessage } = useIntl();
  const [sortingList, setSortingList] = useState(configuration?.[fieldName] || []);
  const [controlSortInput, setControlSortInput] = useState({
    sortField: "byes",
    sortDirection: "ASC",
  });

  useEffect(() => {
    const data = configuration;
    if (isArray(sortingList)) {
      data[fieldName] = sortingList;
    } else {
      data[fieldName] = [];
    }
    handleSetConfiguration(data);

    const sortActive = Object.entries(sortFields)?.filter((item) => {
      return !sortingList?.filter((sortingItem) => item?.[0] === sortingItem?.sortField)?.length;
    })?.[0]?.[0];

    setControlSortInput((prev) => {
      return {
        ...prev,
        sortField: sortActive,
      };
    });
  }, [sortingList, configuration, fieldName, handleSetConfiguration]);

  const changeSort = useCallback(
    (value, field) => {
      setControlSortInput((prev) => ({ ...prev, [field]: value }));
    },
    [setControlSortInput],
  );

  const handleAddSorting = useCallback(() => {
    setSortingList((prev) => [
      ...prev,
      {
        sortField: controlSortInput?.sortField,
        sortDirection: controlSortInput?.sortDirection,
      },
    ]);
  }, [controlSortInput?.sortField, controlSortInput?.sortDirection]);

  const handleSwapItems = useCallback(
    (oldIndex, newIndex) => {
      setSortingList((prev) => swapElements(prev, oldIndex, newIndex));
    },
    [setSortingList],
  );

  const handleRemoveSortingItem = useCallback(
    (index) => {
      setSortingList((prev) => [...prev.filter((item, key) => key !== index)]);
    },
    [setSortingList],
  );

  return (
    <>
      <Row>
        <Col offset={10}>
          <Tooltip title={titleTooltip}>
            <Typography.Title level={5}>{title}</Typography.Title>
          </Tooltip>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item label={"Sort Field"} className={"mb-1"}>
            <Select
              showSearch={true}
              value={controlSortInput?.sortField}
              onChange={(value) => changeSort(value, "sortField")}
            >
              {Object.entries(sortFields)
                ?.filter((item) => {
                  return !sortingList?.filter((sortingItem) => item?.[0] === sortingItem?.sortField)?.length;
                })
                ?.map((item) => (
                  <Select.Option key={item?.[0]} value={item?.[0]}>
                    {item?.[1]}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label={"Sort Direction"} className={"mb-1"}>
            <Select value={controlSortInput?.sortDirection} onChange={(value) => changeSort(value, "sortDirection")}>
              {SORT_DIRECTION_LIST?.map((item) => (
                <Select.Option key={item?.value} value={item?.value}>
                  {item?.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={14} offset={10}>
          <Button type={"primary"} onClick={() => handleAddSorting()}>
            {formatMessage({
              id: "add",
              defaultMessage: "Add",
            })}
          </Button>
        </Col>
        <Col span={17} offset={6}>
          {sortingList?.length ? (
            <List
              size="small"
              bordered
              className={"mt-3"}
              dataSource={sortingList}
              renderItem={(item, index) => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div>
                    <Button
                      onClick={() => handleSwapItems(index, index - 1)}
                      disabled={index === 0}
                      icon={<i className={"fas fa-arrow-up"} />}
                    />
                    <Button
                      onClick={() => handleSwapItems(index, index + 1)}
                      disabled={index === sortingList?.length - 1}
                      icon={<i className={"fas fa-arrow-down"} />}
                      className={"mr-3"}
                    />
                    {sortFields?.[item?.sortField]} ({item?.sortDirection})
                  </div>
                  <Button
                    onClick={() => handleRemoveSortingItem(index)}
                    type={"text"}
                    icon={<i className={"fas fa-trash-can text-danger"} />}
                  ></Button>
                </div>
              )}
            />
          ) : (
            ""
          )}
        </Col>
      </Row>
    </>
  );
};

export default SortingField;
